
  import { mixins } from "vue-class-component";
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class PaginationList extends mixins() {
    @Prop(Number) readonly resultFrom!: number;
    @Prop(Number) readonly resultTo!: number;
    @Prop(Number) readonly total!: number;

    get resultFromValue() {
      return this.resultFrom > this.total ? this.total : this.resultFrom
    }

    get resultToValue() {
      return this.resultTo > this.total ? this.total : this.resultTo
    }
  }
